module.exports = __webpack_public_path__ + "static/media/OutletLarge.f3f50cb0.png";